import React from 'react';
import Locales from 'locales';

const AuthSidebar = () => {
  return (
    <aside className="hidden md:flex fixed left-0 top-0 h-screen w-[420px] overflow-hidden bg-gradient-to-br from-emerald-50 via-teal-50 to-green-100 items-center justify-center">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/5" />

      <div className="absolute top-12 left-12 w-32 h-32 border-2 border-emerald-400 rounded-full opacity-20" />
      <div className="absolute bottom-20 right-12 w-24 h-24 border-2 border-teal-400 rounded-lg opacity-20 animate-pulse" />
      <div className="absolute top-1/3 right-16 w-20 h-20 bg-gradient-to-br from-emerald-300 to-teal-300 rounded-full blur-xl opacity-30 animate-pulse" />

      <div className="relative z-10 flex flex-col items-center justify-center px-8 md:px-12">
        <div className="backdrop-blur-xl bg-white/40 border border-white/60 rounded-3xl shadow-2xl p-8 md:p-10 max-w-sm text-center">
          <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-emerald-700 via-teal-600 to-emerald-700 bg-clip-text text-transparent tracking-tight leading-tight drop-shadow-sm">
            E-HADJ
          </h1>
          <div className="mt-2 h-1 w-20 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-full shadow-lg shadow-emerald-500/50 mx-auto" />

          <p className="text-lg md:text-xl text-gray-800 leading-relaxed font-medium mt-6">
            {Locales.auth.description}
          </p>
        </div>
      </div>
    </aside>
  );
};

export default AuthSidebar;
